export function getGasPriceSkeletonWidth(isTablet: boolean, isMobile: boolean): number | string {
  if (isMobile) {
    return '100%';
  }
  if (isTablet) {
    return 170;
  }
  return 167;
}

export function getGasPriceSkeletonHeight(isTablet: boolean, isMobile: boolean): number | string {
  if (isMobile) {
    return 137;
  }
  return 256;
}
